import { Component, ViewChildren } from "@angular/core";
import { ICellEditorAngularComp } from "ag-grid-angular";
import { MatRadioButton } from "@angular/material/radio";

@Component({
    selector: "radio-cell",
    template: `
        <mat-card>
          <div class="container" tabindex="0" (keydown)="onKeyDown($event)">
            <mat-radio-group class="radio-group" [(ngModel)]="selectedStage">
              @for (stage of stages; track stage) {
                <mat-radio-button class="radio-button" [value]="stage">
                  {{stage}}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </mat-card>
        `,
    styles: [
        `
            .container {
                width: 350px;
            }

            .radio-group {
                display: inline-flex;
                flex-direction: column;
            }

            .radio-button {
                margin: 5px;
            }
        `
    ],
    standalone: false
})
export class MatRadioComponent implements ICellEditorAngularComp {
    private params: any;

    stages: string[];
    selectedStage: string;
    selectedIndex: number;

    @ViewChildren(MatRadioButton) public stageRadios;

    agInit(params: any): void {
        this.params = params;

        this.selectedStage = this.params.value;
        this.stages = this.params.stages;

        this.selectedIndex = this.stages.findIndex(item => {
            return item === this.params.value;
        });
    }

    // dont use afterGuiAttached for post gui events - hook into ngAfterViewInit instead for this
    ngAfterViewInit() {
        this.selectStageBasedOnSelectedIndex();
    }

    private selectStageBasedOnSelectedIndex() {
        this.selectedStage = this.stages[this.selectedIndex];

        // focus on next tick
        let fruitRadio = this.stageRadios.find(radio => radio.value === this.selectedStage);
        window.setTimeout(() => {
            fruitRadio.focus();
        }, 0);
    }

    getValue() {
        return this.selectedStage;
    }

    isPopup(): boolean {
        return true;
    }

    /*
     * A little over complicated for what it is, but the idea is to illustrate how you might navigate through the radio
     * buttons with up & down keys (instead of finishing editing)
     */
    onKeyDown(event): void {
        let key = event.which || event.keyCode;
        if (key === 38 || key === 40) {
            this.preventDefaultAndPropagation(event);

            if (key == 38) {
                // up
                this.selectedIndex = this.selectedIndex === 0 ? this.stages.length - 1 : this.selectedIndex - 1;
            } else if (key == 40) {
                // down
                this.selectedIndex = this.selectedIndex === this.stages.length - 1 ? 0 : this.selectedIndex + 1;
            }
            this.selectStageBasedOnSelectedIndex();
        }
    }

    private preventDefaultAndPropagation(event) {
        event.preventDefault();
        event.stopPropagation();
    }
}